var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-title"},[_vm._v(_vm._s(_vm.product.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }